import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import { RECORD_DELETED_SUCCESSFULLY } from 'components/common/FSBToastify/types';
import { DELETE_CATEGORY } from 'pages/Products/ProductsGraphQL';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import FSBModal from 'components/common/FSBModal';
import DeleteConfirmationAlert from 'components/DeleteConfirmationAlert';
import AllCategory from './components/AllCategory';
import AddEditCategory from './components/AddEditCategory';

const CategoryTab = () => {
  const [showAddRecord, setAddRecord] = useState({
    status: false,
    row: '',
    type: ADD_EDIT_CONSTANT.ADD,
  });

  const [deleteRowId, setDeleteRowId] = useState('');
  const [showDeleteRecord, setDeleteRecord] = useState(false);

  const [deleteCategory] = useMutation(DELETE_CATEGORY, {
    // eslint-disable-next-line no-shadow
    onCompleted: () => {
      toast.success(RECORD_DELETED_SUCCESSFULLY);
      setDeleteRowId('');
      setDeleteRecord(!showDeleteRecord);
    },

    onError: ({ graphQLErrors }) => {
      graphQLErrors.map(({ message }) => {
        return message;
      });
    },
  });

  const toggleDeleteRecord = (id) => {
    setDeleteRecord(!showDeleteRecord);
    setDeleteRowId(id);
  };

  const onDeleteConfirmation = async () => {
    try {
      await deleteCategory({
        variables: { id: deleteRowId },
      });
    } catch (err) {
      toast.error(err);
    }
  };

  const toggleAddRecord = (row, type) => {
    setAddRecord({ status: !showAddRecord.status, row, type });
  };
  const handleClickEdit = (val, type) => {
    toggleAddRecord(val, type);
  };
  return (
    <div>
      <DeleteConfirmationAlert
        open={showDeleteRecord}
        title="Delete"
        message="Do you really want to remove this record?"
        cancelButtonLabel="Close"
        addButtonLabel="Delete"
        onConfirm={onDeleteConfirmation}
        onCancel={toggleDeleteRecord}
      />

      <FSBModal
        title={`${
          showAddRecord.type === ADD_EDIT_CONSTANT.EDIT
            ? showAddRecord.type
            : ADD_EDIT_CONSTANT.ADD
        } Category`}
        closeButtonLabel=""
        confirmButtonLabel=""
        open={showAddRecord.status}
        toggleAlert={toggleAddRecord}
        onClose={toggleAddRecord}
        message=""
        modalClass="right-drawer"
      >
        <AddEditCategory
          toggleAddRecord={toggleAddRecord}
          currentRow={showAddRecord.row}
          type={showAddRecord.type}
        />
      </FSBModal>
      <AllCategory
        toggleDeleteRecord={toggleDeleteRecord}
        handleClickEdit={handleClickEdit}
        toggleAddRecord={toggleAddRecord}
      />
    </div>
  );
};

export default CategoryTab;
